import arrayLikeKeys from "./component-library382.mjs";
import baseKeysIn from "./component-library385.mjs";
import isArrayLike from "./component-library384.mjs";
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
export {
  keysIn as default
};
